<script>
import store from "../../store.js";
import MapHelper from "./MapHelper";
import ImageLayer from "ol/layer/Image";
import TileLayer from "ol/layer/Tile";
import ImageArcGISRestSource from "ol/source/ImageArcGISRest";

export default {
	edviItemVector: "/leip-edvi-fs-proxy/rest/edviFeatureServer/",
	edviItemRaster: "/edvi-webapp/ag/{datasetId}/rest/services/rasterDataset/MapServer",
	edviMaps: "/edvi-webapp/rest/map/load/",
	search(value, additionalParams) {
		var promise = new Promise(function (resolve, reject) {
			var url = "/atlas/iedp/api/Search/DoSearch", // TODO: kažkur iškelti...
				params = this.getSearchParams(value, additionalParams);
			setTimeout(function () {
				window.fetch(url, {
					method: "POST",
					body: JSON.stringify(params),
					headers: {
						"Content-Type": "application/json"
					}
				}).then(function (response) {
					if (response.status == 200) {
						return response.text();
					} else {
						reject();
					}
				}).then(function (text) {
					var records;
					if (text) {
						try {
							var json = JSON.parse(text);
							if (json) {
								records = json["records"];
							}
						} catch (err) {
							// ...
						}
					}
					if (records) {
						resolve(records);
					} else {
						reject();
					}
				}.bind(this), function () {
					reject();
				});
			}.bind(this), store.state.testDelay);
		}.bind(this));
		return promise;
	},
	getSearchParams: function (value, additionalParams) {
		var params = {
			"text": value
		};
		if (!additionalParams) {
			additionalParams = {};
		}
		var provider = additionalParams.provider || "";
		provider = provider.replace(/„/g, "").replace(/”/g, "").replace(/"/g, ""); // Negražus hack'as? Kitaip lyg ir negrąžindavo resultatų, jei reikšmėje pvz. kabutės būdavo??...
		params["records"] = [{
			"type": "MD",
			"start": "0",
			"limit": "500",
			"attributes": [{
				"profile": additionalParams.profile || "",
				"provider": provider,
				"theme": additionalParams.theme || "",
				"category": ""
			}]
		}, {
			"type": "EDVI",
			"start": "0",
			"limit": "500",
			"attributes": []
		}, {
			"type": "Public",
			"start": "0",
			"limit": "500",
			"attributes": [{
				"provider": "",
				"theme": "",
				"category": ""
			}]
		}];
		return params;
	},
	searchRelated(id) {
		var promise = new Promise(function (resolve, reject) {
			var url = "/atlas/similarIEDP/api/SimilarSearch", // TODO: kažkur iškelti...
				params = {
					"uuid": id
				};
			setTimeout(function () {
				window.fetch(url, {
					method: "POST",
					body: JSON.stringify(params),
					headers: {
						"Content-Type": "application/json"
					}
				}).then(function (response) {
					if (response.status == 200) {
						return response.text();
					} else {
						reject();
					}
				}).then(function (text) {
					var records;
					if (text) {
						try {
							var json = JSON.parse(text);
							if (json) {
								records = json["records"];
							}
						} catch (err) {
							// ...
						}
					}
					if (records) {
						resolve(records);
					} else {
						reject();
					}
				}.bind(this), function () {
					reject();
				});
			}.bind(this), store.state.testDelay);
		}.bind(this));
		return promise;
	},
	toggleLikedStatus: function (service) {
		var url = "/atlas/iedp/api/Like/"; // TODO: kažkur iškelti...;
		var promise = new Promise(function (resolve, reject) {
			if (service.liked) {
				url += "DeleteEdrFromLiked";
			} else {
				url += "AddEdrToLiked";
			}
			var params = {
				edrId: service.id,
				edrType: service.type
			};
			setTimeout(function () {
				window.fetch(url, {
					method: "POST",
					body: JSON.stringify(params),
					headers: {
						"Content-Type": "application/json"
					}
				}).then(function (response) {
					if (response.status == 200) {
						return response.text();
					} else {
						reject();
					}
				}).then(function (text) {
					var success;
					if (text) {
						try {
							var json = JSON.parse(text);
							if (json) {
								success = json["Success"];
							}
						} catch (err) {
							// ...
						}
					}
					if (success) {
						service.liked = !service.liked; // Tai labai `tricky` reikalas... Aktualus sinchronizavimui, kad ale turėtume aktualiausią info... FIXME!
						resolve();
					} else {
						reject();
					}
				}.bind(this), function () {
					reject();
				});
			}.bind(this), store.state.testDelay);
		});
		return promise;
	},
	getLegend: function (service) {
		// Hmmm... Ar yra tokių atvejų, kai sluoksniui aktualu pateikti ir legendą iš legendų JSON'o, ir automatiškai sugeneruotą legendą???...
		// TAIP!!!
		// Pvz.: http://kaukas:6080/arcgis/rest/services/geoportal_teikeju/ESO_DUJOS_Public/MapServer
		// Taigi, prie serviso reikia prikabinti dvejopą info: ir kelią į piešinuką iš legendų JSON'o, ir automatiškai sugeneruotos legendos info!!!
		var promise = new Promise(function (resolve, reject) {
			Promise.allSettled([
				this.getCustomLegend(service),
				this.getWmsLegend(service),
				this.getNativeLegend(service)
			]).then(function (values) {
				var legend = {};
				if (values[0].status == "fulfilled") {
					legend["custom"] = values[0].value;
				}
				if (values[1].status == "fulfilled") {
					legend["wms"] = values[1].value;
				}
				if (values[2].status == "fulfilled") {
					legend["native"] = values[2].value;
				}
				resolve(legend);
			}, function () {
				console.warn("Promise.allSettled failed...");
				reject();
			});
		}.bind(this));
		return promise;
	},
	getCustomLegend: function (service) {
		var promise = new Promise(function (resolve, reject) {
			if (service.legend) {
				resolve(service.legend); // TODO: gal to irgi prireiks kada... Tipo legendos piešinuko kelią saugome serviso objekte?
			} else {
				// Bandome ieškoti legendos legendų JSON'e...
				if (service.rawOriginalUrl) {
					this.getCustomLegends().then(function (legends) {
						var url = service.rawOriginalUrl,
							legend;
						legends.some(function (l) {
							if (url.indexOf(l.mapName) != -1) {
								legend = l.legendUrl.lt;
								return true;
							}
						});
						resolve(legend);
					}, function () {
						reject();
					});
				} else {
					reject();
				}
			}
		}.bind(this));
		return promise;
	},
	getCustomLegends: function () {
		var promise = new Promise(function (resolve, reject) {
			if (store.state.legends) {
				resolve(store.state.legends);
			} else {
				window.fetch("/map/resources/config/legends.json", {
					method: "GET",
					headers: {
						"Content-Type": "application/json"
					}
				}).then(function (response) {
					if (response.status == 200) {
						return response.text();
					} else {
						reject();
					}
				}).then(function (text) {
					var legends;
					if (text) {
						try {
							legends = JSON.parse(text);
						} catch (err) {
							// ...
						}
					}
					if (legends) {
						store.commit("setLegends", legends);
						resolve(legends);
					} else {
						reject();
					}
				}.bind(this), function () {
					reject();
				});
			}
		}.bind(this));
		return promise;
	},
	getWmsLegend: function (service) {
		return new Promise(function (resolve, reject) {
			if (!service.layer || !(service.layer instanceof ImageLayer) || (service.layer.getSource() instanceof ImageArcGISRestSource)) {
				reject("Ne WMS sluoksnis");
				return;
			}

			setTimeout(async () => {
				try {
					const src = service.layer.getSource();
					const baseUrl = src.getUrl ? src.getUrl() : service.url;
					const capabilitiesUrl = `${baseUrl}?SERVICE=WMS&REQUEST=GetCapabilities`;

					const response = await fetch(capabilitiesUrl);
					if (!response.ok) throw new Error("Nepavyko gauti WMS GetCapabilities");

					const xmlText = await response.text();
					const parser = new DOMParser();
					const xml = parser.parseFromString(xmlText, "text/xml");

					// Rekursinė funkcija, kuri grąžina sluoksnių hierarchiją
					const parseLayer = (layerEl) => {
						const nameEl = layerEl.querySelector(":scope > Name");
						const titleEl = layerEl.querySelector(":scope > Title");
						const layerName = nameEl ? nameEl.textContent.trim() : null;
						const layerTitle = titleEl ? titleEl.textContent.trim() : layerName || "Nežinomas sluoksnis";

						// Vaikiniai sluoksniai
						const childLayers = Array.from(layerEl.querySelectorAll(":scope > Layer"));
						const hasChildren = childLayers.length > 0;

						// Legenda
						let legendUrl = null;
						const legendUrlNode = layerEl.querySelector(":scope > Style > LegendURL > OnlineResource");
						if (legendUrlNode) {
							legendUrl = legendUrlNode.getAttribute("xlink:href");
						}

						// Suteikiam unikalų ID, jei sluoksnis neturi <Name>
						const uniqueId = layerName || `_group_${Date.now()}_${Math.random().toString(36).slice(2, 7)}`;

						const node = {
							name: uniqueId,
							title: layerTitle,
							children: hasChildren ? childLayers.reverse().map(parseLayer) : [],
						};

						if (legendUrl && !hasChildren) {
							node.legendUrl =
								legendUrl +
								"&layertitle=false&rulelabel=auto&layertitlespace=0&itemfontsize=10&boxspace=2&iconlabelspace=2";
						} else if (!legendUrl && layerName && !hasChildren) {
							node.legendUrl = `${baseUrl}?SERVICE=WMS&REQUEST=GetLegendGraphic&FORMAT=image/png&STYLE=default&LAYER=${layerName}&layertitle=false&rulelabel=auto&layertitlespace=0&itemfontsize=10&boxspace=2&iconlabelspace=2`;
						}

						return node;
					};

					const rootLayers = Array.from(xml.querySelectorAll("Capability > Layer"));
					if (!rootLayers.length) throw new Error("WMS GetCapabilities neturi <Capability><Layer>");

					const parsedLayers = rootLayers.reverse().map(parseLayer);

					resolve(parsedLayers);
				} catch (err) {
					console.warn("Klaida gaunant WMS legendas:", err);
					reject(err);
				}
			}, store.state.testDelay);
		});
	},
	getEsriServiceCapabilities: function (service) {
		var promise = new Promise(function (resolve, reject) {
			if (service.capabilities && service.capabilities["esri"]) {
				resolve();
			} else {
				MapHelper.getServiceCapabilities(service.url, "esri").then(function (capabilities) {
					if (!service.capabilities) {
						service.capabilities = {};
					}
					service.capabilities[capabilities.type] = capabilities.content;
					resolve()
				}, function () {
					reject();
				});
			}
		});
		return promise;
	},
	getNativeLegend: function (service) {
		var promise = new Promise(function (resolve, reject) {
			// Reikia nagrinėti C:\servers\apache-tomcat-7.0.67\webapps\map\resources\js\app\navigation\LayerListItemComponent.js _getAutoGeneratedLegend()!
			// Iš pradžių reikia patikrinti, ar servisas yra reikiamo tipo? Jei taip, reikia gauti "esri" `capabilities` (nes "gisc" negrąžina `currentVersion`)? Jei viskas ok, reikia kreiptis į serviso "/legend?f=json"?
			if (service.layer && (service.layer instanceof TileLayer || service.layer instanceof ImageLayer)) {
				if (service.layer instanceof ImageLayer && !(service.layer.getSource() instanceof ImageArcGISRestSource)) {
					reject(); // ! ImageLayer'is yra ir WMS sluoksnis... Tokiam sluoksniui šiuo metu sprendimo nedarome... Gal koks ir egzistuoja...
				} else {
					this.getEsriServiceCapabilities(service).then(function () {
						if (service.capabilities["esri"] && service.capabilities["esri"].currentVersion && service.capabilities["esri"].currentVersion >= 10) {
							setTimeout(function () {
								window.fetch(service.url + "/legend?f=json", {
									method: "GET",
									headers: {
										"Content-Type": "application/json"
									}
								}).then(function (response) {
									if (response.status == 200) {
										return response.text();
									} else {
										reject();
									}
								}).then(function (text) {
									var legends;
									if (text) {
										try {
											var json = JSON.parse(text);
											if (json) {
												legends = [];
												if (json.layers) {
													json.layers.forEach(function (l) {
														legends[l.layerId] = l.legend;
													});
												}
											}
										} catch (err) {
											// ...
										}
									}
									if (legends) {
										resolve(legends);
									} else {
										reject();
									}
								}.bind(this), function () {
									reject();
								});
							}.bind(this), store.state.testDelay);
						} else {
							reject();
						}
					}, function () {
						reject();
					});
				}
			} else {
				reject();
			}
		}.bind(this));
		return promise;
	},
	getEdviMapData: function (mapId) {
		var promise = new Promise(function (resolve, reject) {
			setTimeout(function () {
				window.fetch(this.edviMaps + mapId, {
					method: "GET"
				}).then(function (response) {
					if (response.status == 200) {
						return response.text();
					} else {
						reject();
					}
				}).then(function (text) {
					var json;
					if (text) {
						try {
							json = JSON.parse(text);
						} catch (err) {
							// ...
						}
					}
					if (json) {
						resolve(json);
					} else {
						reject();
					}
				}.bind(this), function () {
					reject();
				});
			}.bind(this), store.state.testDelay);
		}.bind(this));
		return promise;
	}
}
</script>